import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M13.1 8.333a.833.833 0 1 0 0-1.666.833.833 0 0 0 0 1.666Z" fill="currentColor" /> <path d="M10.6 3.958h6.041V10l-5.58 5.559a1.667 1.667 0 0 1-2.392-.04l-3.661-3.902a1.667 1.667 0 0 1 .06-2.342L10.6 3.958Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);